"use client";

import Link from 'next/link'
import React from 'react'
import { Autoplay, Navigation } from 'swiper/modules';
import { Swiper, SwiperSlide } from 'swiper/react'
// import '../../../app/global.css'


import "swiper/css";
import urls from '@/utils/urls/urls';
import Image from 'next/image';

// import "./styles.css";


export default function PartnersFeatured({ brands }: { brands: any }) {


    return (
        <>
            <div className="service-slider owl-carousel">
                <Swiper
                    slidesPerView={2}
                    spaceBetween={30}
                    modules={[Autoplay, Navigation]}
                    navigation={{
                        prevEl: ".destination-card2-prev",
                        nextEl: ".destination-card2-next",
                    }}
                    // breakpoints={{
                    //     320: { slidesPerView: 1, spaceBetween: 10 },
                    //     640: { slidesPerView: 2, spaceBetween: 20 },
                    //     1024: { slidesPerView: 3, spaceBetween: 30 }
                    // }}

                    // loop={true}
                    className="mySwiper "
                >
                    {/* <SwiperSlide> */}
                    {
                        brands?.map((brand: any) => (
                            <SwiperSlide key={brand?.id}>
                                <Link href={brand?.btn_link} target='__blank'>
                                    {/* <img src={urls?.image + brand?.logo} alt="thumb" className="corporate-logo corporate-logo-lg" /> */}
                                    {/* <img src={urls?.image + brand?.logo} alt="thumb" className="corporate-logo corporate-logo-lg" /> */}
                                    <img
                                        src={urls?.image + brand?.logo} alt="thumb" className="corporate-logo corporate-logo-lg"
                                        // width={500} // Desired width of the image
                                        // height={300} // Desired height of the image
                                    />
                                </Link>
                            </SwiperSlide>
                        ))
                    }
                    {/* <SwiperSlide>
                        <Link href={"https://www.pailung.com.tw"} target='__blank'>
                            <img src="../assets/img/partner/pailung_logo.jpg" alt="thumb" className="corporate-logo corporate-logo-lg" />
                        </Link>
                    </SwiperSlide>
                    <SwiperSlide>
                        <Link href={"https://www.vanguardpailung.com"} target='__blank'>
                            <img src="../assets/img/partner/VanguardPaiLung.jpg" alt="thumb" className="corporate-logo corporate-logo-lg" />
                        </Link>
                    </SwiperSlide> */}
                    {/* <SwiperSlide className="service-item">
                            <span className="count">01</span>
                            <div className="service-img">
                                <img src="../assets/img/service/33.jpg" alt="" className="" />
                            </div>
                            <div className="service-icon">
                                <img src="../assets/img/icon/solar.svg" alt="" />
                            </div>
                            <div className="service-content">
                                <h4 className="service-title pt-2">
                                    <Link href="/service/123">Machine & Factory Audits</Link>
                                </h4>
                                <p className="service-text">
                                Our highly trained experts will come to you and inspect your Vanguard Pai Lung machine(s) on a 35 point checklist. We will give you insight on improving factory safety and conditions while maximizing productivity and efficiency.
                                </p>
                                <Link href="/service/123" className="theme-btn">
                                    Learn More
                                    <i className="fas fa-arrow-right" />
                                </Link>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className="service-item">
                            <span className="count">02</span>
                            <div className="service-img">
                                <img src="../assets/img/service/33.jpg" alt="" className="" />
                            </div>
                            <div className="service-icon">
                                <img src="../assets/img/icon/solar.svg" alt="" />
                            </div>
                            <div className="service-content">
                                <h4 className="service-title pt-2">
                                    <Link href="/service/123">Repairs</Link>
                                </h4>
                                <p className="service-text">
                                If you have a damaged cylinder, send it to us and our experienced inspectors will determine if it can be repaired or not. We will fix it and return it promptly to you.
                                </p>
                                <Link href="/service/123" className="theme-btn">
                                    Learn More
                                    <i className="fas fa-arrow-right" />
                                </Link>
                            </div>
                        </SwiperSlide>
                        <SwiperSlide className="service-item">
                            <span className="count">03</span>
                            <div className="service-img">
                                <img src="../assets/img/service/33.jpg" alt="" className="" />
                            </div>
                            <div className="service-icon">
                                <img src="../assets/img/icon/solar.svg" alt="" />
                            </div>
                            <div className="service-content">
                                <h4 className="service-title pt-2">
                                    <Link href="/service/123">KMS Support</Link>
                                </h4>
                                <p className="service-text">
                                Get in contact with the expert software developers who built KMS from scratch. Email kmssupport@vanguardpailung.com to get started.
                                </p>
                                <Link href="/service/123" className="theme-btn">
                                    Learn More
                                    <i className="fas fa-arrow-right" />
                                </Link>
                            </div>
                        </SwiperSlide> */}
                    {/* <SwiperSlide className="service-item">
                            <span className="count">03</span>
                            <div className="service-img">
                                <img src="../assets/img/service/33.jpg" alt="" className="" />
                            </div>
                            <div className="service-icon">
                                <img src="../assets/img/icon/solar.svg" alt="" />
                            </div>
                            <div className="service-content">
                                <h4 className="service-title pt-2">
                                    <Link href="/service/123">KMS Support</Link>
                                </h4>
                                <p className="service-text">
                                Get in contact with the expert software developers who built KMS from scratch. Email kmssupport@vanguardpailung.com to get started.
                                </p>
                                <Link href="/service/123" className="theme-btn">
                                    Learn More
                                    <i className="fas fa-arrow-right" />
                                </Link>
                            </div>
                        </SwiperSlide> */}
                    {/* </SwiperSlide> */}
                    {/* <SwiperSlide>
                        <div className="service-item">
                            <span className="count">01</span>
                            <div className="service-img">
                                <img src="../assets/img/service/33.jpg" alt="" className="img-fluid100" />
                            </div>
                            <div className="service-icon">
                                <img src="../assets/img/icon/solar.svg" alt="" />
                            </div>
                            <div className="service-content">
                                <h4 className="service-title pt-2">
                                    <Link href="/service/123">Swing Mechine</Link>
                                </h4>
                                <p className="service-text">
                                    There are many variations of randomised words which don't
                                    look even slightly believable.
                                </p>
                                <Link href="/service/123" className="theme-btn">
                                    Learn More
                                    <i className="fas fa-arrow-right" />
                                </Link>
                            </div>
                        </div>
                    </SwiperSlide> */}
                </Swiper>
            </div>
        </>

    )
}
